import { useEventListener } from '@vueuse/core';

const toggleCardsLogic = () => {
    const cardClose = document.getElementById('corner-card-close');
    const cornerCard = document.querySelector('.corner-card');
    const cornerImage = document.querySelector('.corner-image');

    function toggleImageClose() {
        if (cornerCard && cornerImage) {
            cornerCard.classList.toggle('d-none');
        }
    }

    if (cardClose && cornerImage) {
        useEventListener(cardClose, 'click', toggleImageClose);
        useEventListener(cornerImage, 'click', toggleImageClose);
    }
};

useEventListener(document, 'DOMContentLoaded', toggleCardsLogic);
